import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  DialogTitle,
  Paper,
  Button,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  PaginationItem,
  Drawer,
  Alert,
  Snackbar,
} from "@mui/material";
import {
  Close as CloseIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Assignment as AssignmentIcon,
  ExpandLess,
  ExpandMore,
  FilterList as FilterListIcon,
  Add as AddIcon,
  MoreHoriz as MoreHorizIcon,
} from "@mui/icons-material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { styled } from "@mui/material/styles";
import AddDriver from "./AddDriver";
import ViewDriver from "./ViewDriver";
import DateRangePickerComponent from "../../../Roles and Permissions/Filters/Date";
import ApplyButton from "../../../Roles and Permissions/Filters/ApplyButton";
import ResetButton from "../../../Roles and Permissions/Filters/ResetButton";
import { api, get, put } from "../../../../../utils/api";
import FilterSidebar from "../../../../../Components/Masters/Filter/FilterSidebar";
import DynamicFacilityFilter from "../../../Roles and Permissions/Filters/UserFilters/dynamicFacilityFilter";
import LogisticVendorFilter from "../../../Roles and Permissions/Filters/UserFilters/LogisticVendorFilter";
import NoDataFound from "../../../../../Components/Masters/NoDataFound";
import PaginationBox from "../../../../../Components/Masters/Pagination";
import MainDashboardLayout from "../../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../../Layout/MastersSidebar";
import Unauthorized from "../../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../../context/AuthContext";
import TopMenu from "../../../../../Components/Masters/TopMenu";
import {FacilityColumnHeading,
  facilityDataCellSx,
  getFacilityName,
  shouldShowFacilityColumn, FacilityDataCell, MasterDateDataCell } from "../../../../../utils/facilityColumn";

const ListDriver = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = showFacilityColumn
    ? "11% 12% 17% 17% 17% 16% 10%"
    : "13% 20% 20% 20% 19% 8%";

  const [facilities, setEquipment] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addFacility, setAddFacility] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Facility: false,
    LogisticVendor: false,
  });
  const [viewFacility, setViewFacility] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [selectedFacilities, setSelectedFacilities] = useState([]); // Store selected facility name
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);

  const [selectedLogisticVendor, setSelectedLogisticVendor] = useState([]); // Correct naming
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [errors, setErrors] = useState({
    Date: false,
    Facility: false,
    LogisticVendor: false,
  });

  const filters = user?.facilityManger
    ? ["Date", "Vendor Name"]
    : ["Date", "Facility", "Vendor Name"];
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    selectedFacilities: [],
    selectedLogisticVendor: [],
  });

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height
      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [facilities]);
  // Function to render the selected filter component based on user's choice

  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );

      case "Facility":
        return (
          <DynamicFacilityFilter
            url={`${api}/driver/master/getAll`}
            selectedFacilities={tempFilter?.selectedFacilities}
            setSelectedFacilities={(facility) => {
              setTempFilter((prev) => ({
                ...prev,
                selectedFacilities: facility,
              }));
            }}
            errors={errors.Facility}
          />
        );
      case "Vendor Name":
        return (
          <LogisticVendorFilter
            url={`${api}/driver/master/getAll`}
            selectedLogisticVendor={tempFilter?.selectedLogisticVendor}
            setSelectedLogisticVendor={(vendor) => {
              setTempFilter((prev) => ({
                ...prev,
                selectedLogisticVendor: vendor,
              }));
            }}
            errors={errors.LogisticVendor}
          />
        );

      default:
        return null;
    }
  };
  const handleMenuClick = (event, facility) => {
    setAnchorEl(event.currentTarget);
    setdataView(facility);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddFacility(true);
    setViewFacility(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewFacility(true);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleDeleteAggree = () => {
    if (dataView && dataView._id) {
      put(`/driver/master/delete?id=${dataView._id}`)
        .then((res) => {
          setDeleteDialog(false);
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          fetchFacilities();
        })
        .catch((err) => {
          console.log(err);
          setsnackOpen({
            open: true,
            message: err.response?.data?.message ?? "Network Error",
            severity: "error",
          });
          fetchFacilities();
        });
    } else {
      setsnackOpen({
        open: true,
        message: "No facility selected for deletion",
        severity: "error",
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // fetching facility data
  const fetchFacilities = async (filters = filtersToApply) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(`/driver/master/getAll?${queryParams}`);

      setEquipment(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchFacilities();
  }, [page, rowsPerPage, sortConfig]);

  // default filters to apply
  const filtersToApply = {
    facility: tempFilter?.selectedFacilities.join(","),
    logisticsVendor: tempFilter?.selectedLogisticVendor.join(","), // Correct variable name
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: "",
      Facility: "",
      LogisticVendor: "",
    };

    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date

      // Ensure that startDate and endDate are not greater than today's date
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedLogisticVendor(tempFilter?.selectedLogisticVendor);
    setSelectedFacilities(tempFilter?.selectedFacilities);
    setPage(1);
    fetchFacilities();
    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  // Applying reset filters
  const handleResetFilters = () => {
    setTempFilter({
      selectedFacilities: [],
      selectedLogisticVendor: [],
      startDate: null,
      endDate: null,
    });
    setStartDate(null);
    setEndDate(null);
    setIsFiltersApplied(false);
    setAppliedFilters({});
    setErrors({});
    fetchFacilities({
      country: [],
      facilityName: [],
      startDate: "",
      endDate: "",
    });
    setDrawerFilterOpen(false);
  };
  // handle the applied filters for styling

  const handleAppliedFilters = () => {
    const isDateApplied =
      tempFilter?.startDate || tempFilter?.endDate ? true : false;
    const isSelectedVednor =
      tempFilter?.selectedLogisticVendor.length > 0 ? true : false;
    const isFacilityApplied =
      tempFilter?.selectedFacilities.length > 0 ? true : false;

    setIsFiltersApplied(isDateApplied || isSelectedVednor || isFacilityApplied);

    setAppliedFilters({
      ...appliedFilters,
      Date: isDateApplied,
      Facility: isFacilityApplied,
      LogisticVendor: isSelectedVednor,
    });
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(() => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      selectedFacilities: selectedFacilities,
      selectedLogisticVendor: selectedLogisticVendor,
      startDate: startDate,
      endDate: endDate,
    });
    setDrawerFilterOpen(false);
    setErrors({ Date: false, Role: false });
  };

  console.log("inside", tempFilter);

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Snackbar
            open={snackOpen.open}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          >
            <Alert
              // onClose={handleClose}
              severity={snackOpen.severity}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {snackOpen.message}
              {/* Add user Successfully */}
            </Alert>
          </Snackbar>

          <AddDriver
            addFacility={addFacility}
            setAddFacility={setAddFacility}
            selectedFacility={dataView}
            setsnackOpen={setsnackOpen}
            fetchFacilities={fetchFacilities}
          />
          <ViewDriver
            viewFacility={viewFacility}
            setViewFacility={setViewFacility}
            selectedFacility={dataView}
            setsnackOpen={setsnackOpen}
            fetchFacilities={fetchFacilities}
            handleEdit={handleEdit}
          />

          {deleteDialog && (
            <Dialog
              open={deleteDialog}
              // onClose={handleCancelDelete}
            >
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you really want to delete this entry?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setDeleteDialog(false)} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleDeleteAggree} color="secondary">
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {drawerFilterOpen && (
            <Drawer
              anchor="right"
              open={drawerFilterOpen}
              onClose={() => handleFilterDrawer()}
              sx={{
                backgroundColor: "transparent",
                "& .MuiDrawer-paper": {
                  // This targets the paper component within the Drawer
                  backgroundColor: "transparent", // Make paper transparent
                  boxShadow: "none", // Optional: Remove any shadow
                  width: "50%",
                },
              }}
            >
              <Box
                display="flex"
                gap={3}
                sx={{
                  width: "100%",
                  display: "flex",
                  overflowX: "hidden",
                  maxWidth: "100%",
                  justifyContent: "space-btween",
                  height: "100%",
                  backgroundColor: "transparent",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#f5f5f5",
                    height: "3%",
                    padding: "13px",
                    margin: "30px 0 0 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "80%",
                    width: "3%",
                  }}
                >
                  <IconButton
                    onClick={() => handleFilterDrawer()}
                    sx={{ color: "black" }}
                  >
                    <CloseIcon sx={{ fontSize: "1.2rem" }} />
                  </IconButton>
                </Box>
                <Box sx={{ display: "flex", width: "100%", height: "100vh" }}>
                  {/* Sidebar for selecting the filter */}
                  <FilterSidebar
                    {...{
                      setSelectedFilter,
                      selectedFilter,
                      filters,
                      appliedFilters,
                    }}
                  />

                  {/* Filter content area */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#F9F9F9",
                      padding: "20px",
                      height: "100vh",
                      paddingBottom: "20%",
                    }}
                  >
                    {renderSelectedFilter()}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: "3%",
                        position: "fixed",
                        bottom: "20px",
                        ml: 3,
                        mr: 3,
                      }}
                    >
                      <ApplyButton handleApply={handleApplyFilters} />
                      <ResetButton handleReset={handleResetFilters} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          )}

          {/* <Box
            // container
            // // alignItems="center"
            sx={{
              pt: "2rem",
              // display: "flex",
              justifyContent: "space-between",
              width:!user?.companyAdmin? "96%": "100%",
              // justifyContent: "flex-end",
              // ml: "20%",
            }}
          >
            <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                  paddingLeft: "0",
                }}
              >
                {"Scope 3"}
              </Typography>
            </Box>
            <Box item xs={6} sx={{ textAlign: "right", my: "1rem" }}>
              <Button
                variant="contained"
                onClick={() => setDrawerFilterOpen(true)}
                // endIcon={<FilterListIcon />}
                sx={{
                  margin:!user?.companyAdmin? "0px 10px 5px 0px":"0px",
                  backgroundColor: "#ffffff",
                  color: "black",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                  "&:hover .dot-icon": {
                    color: "#FFFFFF", // Change dot color on button hover
                  },
                  // display:"flex"
                }}
              >
                Filter
                <FilterListIcon />
                {/* {isFiltersApplied */}
          {/* {(tempFilter?.selectedFacilities.length > 0 ||
                  tempFilter?.selectedLogisticVendor.length > 0 ||
                  tempFilter?.startDate ||
                  tempFilter?.endDate) && (
                  <FiberManualRecordIcon
                    className="dot-icon"
                    sx={{
                      fontSize: "10px",
                      color: "#488257",
                      marginLeft: "5px",
                    }}
                  />
                )}
              </Button>
              {!user?.companyAdmin && (
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  sx={{
                    margin: "0px -36px 5px 0px",
                    backgroundColor: "#1c486b",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddFacility(true);
                    setdataView(null);
                  }}
                >
                  Add New
                </Button>
              )}
            </Box> 
          </Box> */}
          <TopMenu
            setData={setdataView}
            setAddData={setAddFacility}
            {...{
              heading: "Scope 3",
              setDrawerFilterOpen,
              filterApplied:
                tempFilter?.selectedFacilities.length > 0 ||
                tempFilter?.selectedLogisticVendor.length > 0 ||
                tempFilter?.startDate ||
                tempFilter?.endDate,
            }}
          />
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ flex: 1, overflow: "hidden" }}
          >
            <Box>
              <Box sx={{ margin: "16px" }}>
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "left",
                    display: "flex",
                    flexDirection: "column",
                    // padding: "0px",
                  }}
                >
                  Driver Master
                </Box>
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  ...(showFacilityColumn && { alignItems: "stretch" }),
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 16px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Date
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("createdAt", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "createdAt" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                {showFacilityColumn && (
                  <FacilityColumnHeading
                    handleSort={handleSort}
                    sortConfig={sortConfig}
                  />
                )}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Logistics Vendor
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("logisticsVendor", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "logisticsVendor" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("logisticsVendor", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "logisticsVendor" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Driver Name
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("driverName", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "driverName" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("driverName", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "driverName" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>

                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Mobile Number
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("phone", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "phone" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("phone", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "phone" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "left",
                    borderRight: "1px solid #ddd",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  Driver's License
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => handleSort("licenseNumber", "asc")}
                    >
                      <ExpandLess
                        sx={{
                          color:
                            sortConfig.key === "licenseNumber" &&
                            sortConfig.direction === "asc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleSort("licenseNumber", "desc")}
                    >
                      <ExpandMore
                        sx={{
                          color:
                            sortConfig.key === "licenseNumber" &&
                            sortConfig.direction === "desc"
                              ? "blue"
                              : "black",
                          margin: "-10px",
                          fontSize: "20px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  Action
                  {/* <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyItems:"center",
                      marginTop: "2px",
                      marginLeft: "10px",
                    }}
                  ></Box> */}
                </Typography>
              </Box>

              {facilities.length === 0 ? (
                <NoDataFound />
              ) : (
                facilities.map((item, index) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: columnWidth,
                      ...(showFacilityColumn && { alignItems: "stretch" }),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <Typography
                      sx={{
                        padding: "8px 16px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {/* {new Date(equipments.createdAt).toLocaleDateString()} */}
                      {new Date(item.createdAt).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </Typography>

                    {showFacilityColumn && (
                      <FacilityDataCell>
                        {getFacilityName(item) || "N/A"}
                      </FacilityDataCell>
                    )}

                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {item.logisticsVendor?.logisticVendorLegalName}
                    </Typography>

                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {item.driverName || "N/A"}
                    </Typography>

                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {item.phone}
                    </Typography>
                    <Typography
                      sx={{
                        padding: "8px 12px",
                        textAlign: "left",
                        borderRight: "1px solid #ddd",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      {item.licenseNumber}
                    </Typography>
                    <Box
                      sx={{
                        padding: "1px",
                        textAlign: "center",
                      }}
                    >
                      <IconButton
                        onClick={(event) => handleMenuClick(event, item, index)}
                      >
                        <MoreHorizIcon
                          sx={{ fontWeight: "bold", color: "black" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>

          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              totalPages={totalPages}
              page={page}
              handleChangePage={handleChangePage}
              StyledPaginationItem={StyledPaginationItem}
              isShortContent={isShortContent} // Pass this state to PaginationBox
            />
          )}

          {/* Menu for Actions */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                width: "120px",
                border: "1px solid #ddd",
                marginLeft: "-47px",
              },
            }}
          >
            {user?.companyAdmin ? (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
                  <AssignmentIcon
                    sx={{ marginRight: "8px", fontSize: "large" }}
                  />
                  View Logs
                </MenuItem>
                <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
                  <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Edit
                </MenuItem>
                <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
                  <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
                  Delete
                </MenuItem>
              </>
            )}
          </Menu>
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default ListDriver;
